import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { T01Component } from './test/t01/t01.component';
 

const routes: Routes = [
  {
    path:'dashbord',
    loadChildren:()=>import('./shared/component/demo/demo.module').then(m=>m.DemoModule)
  },
  {
    path:'',
    loadChildren:()=>import('./shared/component/demo/demo.module').then(m=>m.DemoModule)
  },
  {
    path:'login',
    loadChildren:()=>import('./shared/component/login/login.module').then(m=>m.LoginModule)
  },
  {
    path:'country',
    loadChildren:()=>import('./components/country/country.module').then(m=>m.CountryModule)
  },
  {
    path:'province',
    loadChildren:()=>import('./components/province/province.module').then(m=>m.ProvinceModule)
  },
  {
    path:'district',
    loadChildren:()=>import('./components/district/district.module').then(m=>m.DistrictModule)
  },
  {
    path:'sub-district',
    loadChildren:()=>import('./components/sub-district/sub-district.module').then(m=>m.SubDistrictModule)
  },
  {
    path:'student',
    loadChildren:()=>import('./components/student/student.module').then(m=>m.StudentModule)
  },
  
  {
    path:'alive-with',
    loadChildren:()=>import('./components/alive-with/alive-with.module').then(m=>m.AliveWithModule)
  },
  {
    path:'classroom',
    loadChildren:()=>import('./components/classroom/classroom.module').then(m=>m.ClassroomModule)
  },
  {
    path:'classroom-type',
    loadChildren:()=>import('./components/classroom-type/classroom-type.module').then(m=>m.ClassroomTypeModule)
  },
  {
    path:'ethnicity',
    loadChildren:()=>import('./components/ethnicity/ethnicity.module').then(m=>m.EthnicityModule)
  },
  {
    path:'gendar',
    loadChildren:()=>import('./components/gendar/gendar.module').then(m=>m.GendarModule)
  },
  {
    path:'nationality',
    loadChildren:()=>import('./components/nationality/nationality.module').then(m=>m.NationalityModule)
  },
  {
    path:'parent-status',
    loadChildren:()=>import('./components/parent-status/parent-status.module').then(m=>m.ParentStatusModule)
  },
  {
    path:'religion',
    loadChildren:()=>import('./components/religion/religion.module').then(m=>m.ReligionModule)
  },
  {
    path:'change-password',
    loadChildren:()=>import('./shared/component/change-password/change-password.module').then(m=>m.ChangePasswordModule)
  },
  {
    path:'edit-field',
    loadChildren:()=>import('./components/edit-field/edit-field.module').then(m=>m.EditFieldModule)
  }
  ,
  {
    path:'edit-request',
    loadChildren:()=>import('./components/edit-request/edit-request.module').then(m=>m.EditRequestModule)
  }
  ,
  {
    path:'active-time',
    loadChildren:()=>import('./components/active-time/active-time.module').then(m=>m.ActiveTimeModule)
  }
  ,
  {
    path:'activity-student',
    loadChildren:()=>import('./components/activity-student/activity-student.module').then(m=>m.ActivityStudentModule)
  }
  ,
  {
    path:'curriculum',
    loadChildren:()=>import('./components/curriculum/curriculum.module').then(m=>m.CurriculumModule)
  }
  ,
  {
    path:'education-background',
    loadChildren:()=>import('./components/education-background/education-background.module').then(m=>m.EducationBackgroundModule)
  }
  ,
  {
    path:'practitioner-level',
    loadChildren:()=>import('./components/practitioner-level/practitioner-level.module').then(m=>m.PractitionerLevelModule)
  }
  ,
  {
    path:'teacher',
    loadChildren:()=>import('./components/teacher/teacher.module').then(m=>m.TeacherModule)
  }
  ,
  {
    path:'teacher-work',
    loadChildren:()=>import('./components/teacher-work/teacher-work.module').then(m=>m.TeacherWorkModule)
  }
  ,
  {
    path:'teachers-develop',
    loadChildren:()=>import('./components/teachers-develop/teachers-develop.module').then(m=>m.TeachersDevelopModule)
  }
  ,
  {
    path:'practicle',
    loadChildren:()=>import('./components/practicle/practicle.module').then(m=>m.PracticleModule)
  },
  {
    path:'student-home-visit',
    loadChildren:()=>import('./components/student-home-visit/student-home-visit.module').then(m=>m.StudentHomeVisitModule)
  },
  {
    path:'sdq-table',
    loadChildren:()=>import('./components/sdq-table/sdq-table.module').then(m=>m.SdqTableModule)
  },
  {
    path:'sdq-teacher',
    loadChildren:()=>import('./components/sdq-table/sdq-teacher.module').then(m=>m.SdqTeacherModule)
  },
  {
    path:'sdq-parent',
    loadChildren:()=>import('./components/sdq-table/sdq-parent.module').then(m=>m.SdqParentModule)
  }
  ,
  {
    path:'year-term',
    loadChildren:()=>import('./components/year-term/year-term.module').then(m=>m.YearTermModule)
  }
  ,
  {
    path:'check-student',
    loadChildren:()=>import('./components/check-student/check-student.module').then(m=>m.CheckStudentModule)
  }
  ,
  {
    path:'users',
    loadChildren:()=>import('./components/users/users.module').then(m=>m.UsersModule)
  }
  ,
  {
    path:'depression',
    loadChildren:()=>import('./components/depression/depression.module').then(m=>m.DepressionModule)
  }
  ,
  {
    path:'emotional-quotient',
    loadChildren:()=>import('./components/emotional-quotient/emotional-quotient.module').then(m=>m.EmotionalQuotientModule)
  }
  ,
  {
    path:'stress',
    loadChildren:()=>import('./components/stress/stress.module').then(m=>m.StressModule)
  }
  ,
  {
    path:'student-consultant',
    loadChildren:()=>import('./components/student-consultant/student-consultant.module').then(m=>m.StudentConsultantModule)
  }
  ,
  {
    path:'student-filter',
    loadChildren:()=>import('./components/student-filter/student-filter.module').then(m=>m.StudentFilterModule)
  }
  ,
  {
    path:'student-help',
    loadChildren:()=>import('./components/student-help/student-help.module').then(m=>m.StudentHelpModule)
  }
  ,
  {
    path:'student-scolar',
    loadChildren:()=>import('./components/student-scolar/student-scolar.module').then(m=>m.StudentScolarModule)
  }
  ,
  {
    path:'student-support',
    loadChildren:()=>import('./components/student-support/student-support.module').then(m=>m.StudentSupportModule)
  }
  ,{path: 't01',component: T01Component}
  ,
  {
    path:'teaching-schedule',
    loadChildren:()=>import('./components/teaching-schedule/teaching-schedule.module').then(m=>m.TeachingScheduleModule)
  }
  ,
  {
    path:'student-send-to',
    loadChildren:()=>import('./components/student-send-to/student-send-to.module').then(m=>m.StudentSendToModule)
  }
  ,
  {
    path:'student-report',
    loadChildren:()=>import('./components/student-report/student-report.module').then(m=>m.StudentReportModule)
  }
  ,
  {
    path:'teacher-report',
    loadChildren:()=>import('./components/teacher-report/teacher-report.module').then(m=>m.TeacherReportModule)
  },
    {
    path:'sar-main-menu',
    loadChildren:()=>import('./components/all-sar/sar-main-menu/sar-main-menu.module').then(m=>m.SarMainMenuModule)
  }
  ,
  {
    path:'sar-presonal-data',
    loadChildren:()=>import('./components/all-sar/sar-presonal-data/sar-presonal-data.module').then(m=>m.SarPresonalDataModule)
  },
  {
    path:'sar-presonal-leave-data',
    loadChildren:()=>import('./components/all-sar/sar-presonal-leave-data/sar-presonal-leave-data.module').then(m=>m.SarPresonalLeaveDataModule)
  },
  {
    path:'sar-teaching-schedule',
    loadChildren:()=>import('./components/all-sar/sar-teaching-schedule/sar-teaching-schedule.module').then(m=>m.SarTeachingScheduleModule)
  },
  {
    path:'sar-courses-year-term',
    loadChildren:()=>import('./components/all-sar/sar-courses-year-term/sar-courses-year-term.module').then(m=>m.SarCoursesYearTermModule)
  },
  {
    path:'sar-another-speacial-duty',
    loadChildren:()=>import('./components/all-sar/sar-another-speacial-duty/sar-another-speacial-duty.module').then(m=>m.SarAnotherSpeacialDutyModule)
  }
  ,
  {
    path:'sar-learning-management-plan',
    loadChildren:()=>import('./components/all-sar/sar-learning-management-plan/sar-learning-management-plan.module').then(m=>m.SarLearningManagementPlanModule)
  } ,
  {
    path:'sar-media-production',
    loadChildren:()=>import('./components/all-sar/sar-media-production/sar-media-production.module').then(m=>m.SarMediaProductionModule)
  },
  {
    path:'sar-integrated-learning',
    loadChildren:()=>import('./components/all-sar/sar-integrated-learning/sar-integrated-learning.module').then(m=>m.SarIntegratedLearningModule)
  },
  {
    path:'sar-research-in-class',
    loadChildren:()=>import('./components/all-sar/sar-research-in-class/sar-research-in-class.module').then(m=>m.SarResearchInClassModule)
  },
  {
    path:'sar-student-assign',
    loadChildren:()=>import('./components/all-sar/sar-student-assign/sar-student-assign.module').then(m=>m.SarStudentAssignModule)
  }
  ,
  {
    path:'sar-lecturer-invite',
    loadChildren:()=>import('./components/all-sar/sar-lecturer-invite/sar-lecturer-invite.module').then(m=>m.SarLecturerInviteModule)
  }
  ,
  {
    path:'sar-teaching-format',
    loadChildren:()=>import('./components/all-sar/sar-teaching-format/sar-teaching-format.module').then(m=>m.SarTeachingFormatModule)
  }
  ,
  {
    path:'sar-teaching-condition',
    loadChildren:()=>import('./components/all-sar/sar-teaching-condition/sar-teaching-condition.module').then(m=>m.SarTeachingConditionModule)
  }
  ,
  {
    path:'sar-self-development',
    loadChildren:()=>import('./components/all-sar/sar-self-development/sar-self-development.module').then(m=>m.SarSelfDevelopmentModule)
  }
  ,
  {
    path:'sar-award',
    loadChildren:()=>import('./components/all-sar/sar-award/sar-award.module').then(m=>m.SarAwardModule)
  }
  ,
  {
    path:'sar-invited-speaker',
    loadChildren:()=>import('./components/all-sar/sar-invited-speaker/sar-invited-speaker.module').then(m=>m.SarInvitedSpeakerModule)
  }
  ,
  {
    path:'sar-teaching-result',
    loadChildren:()=>import('./components/all-sar/sar-teaching-result/sar-teaching-result.module').then(m=>m.SarTeachingResultModule)
  }
  ,
  {
    path:'sar-performing-special-duties',
    loadChildren:()=>import('./components/all-sar/sar-performing-special-duties/sar-performing-special-duties.module').then(m=>m.SarPerformingSpecialDutiesModule)
  }
  ,
  {
    path:'sar-student-estimate-teaching',
    loadChildren:()=>import('./components/all-sar/sar-student-estimate-teaching/sar-student-estimate-teaching.module').then(m=>m.SarStudentEstimateTeachingModule)
  }
  ,
  {
    path:'sar-self-assessment',
    loadChildren:()=>import('./components/all-sar/sar-self-assessment/sar-self-assessment.module').then(m=>m.SarSelfAssessmentModule)
  }
  ,
  {
    path:'sar-quality-of-learners',
    loadChildren:()=>import('./components/all-sar/sar-quality-of-learners/sar-quality-of-learners.module').then(m=>m.SarQualityOfLearnersModule)
  }
  ,
  {
    path:'sar-quality-evidence',
    loadChildren:()=>import('./components/all-sar/sar-quality-evidence/sar-quality-evidence.module').then(m=>m.SarQualityEvidenceModule)
  }
  ,
  {
    path:'sar-standard2',
    loadChildren:()=>import('./components/all-sar/sar-standard2/sar-standard2.module').then(m=>m.SarStandard2Module)
  }
  ,
  {
    path:'sar-standard3',
    loadChildren:()=>import('./components/all-sar/sar-standard3/sar-standard3.module').then(m=>m.SarStandard3Module)
  }
  ,
  {
    path:'sar-standard4',
    loadChildren:()=>import('./components/all-sar/sar-standard4/sar-standard4.module').then(m=>m.SarStandard4Module)
  }
  ,
  {
    path:'sar-quality-evidence2',
    loadChildren:()=>import('./components/all-sar/sar-quality-evidence2/sar-quality-evidence2.module').then(m=>m.SarQualityEvidenceModule)
  }
  ,
  {
    path:'sar-quality-evidence3',
    loadChildren:()=>import('./components/all-sar/sar-quality-evidence3/sar-quality-evidence3.module').then(m=>m.SarQualityEvidenceModule)
  }
  ,
  {
    path:'sar-quality-evidence4',
    loadChildren:()=>import('./components/all-sar/sar-quality-evidence4/sar-quality-evidence4.module').then(m=>m.SarQualityEvidenceModule)
  },
  {
    path:'sar-competency-assessment',
    loadChildren:()=>import('./components/all-sar/sar-competency-assessment/sar-competency-assessment.module').then(m=>m.SarCompetencyAssessmentModule)
  },
  {
    path:'sar-crud-assessment',
    loadChildren:()=>import('./components/all-sar/sar-crud-assessment/sar-crud-assessment.module').then(m=>m.SarCrudAssessmentModule)
  },
  {
    path:'sar',
    loadChildren:()=>import('./components/all-sar/sar/sar.module').then(m=>m.SarModule)
  }
  ,
  {
    path:'sar-input',
    loadChildren:()=>import('./components/all-sar/sar-input/sar-input.module').then(m=>m.SarInputModule)
  }
  ,
  {
    path:'sar-activities',
    loadChildren:()=>import('./components/all-sar/sar-activities/sar-activities.module').then(m=>m.SarActivitiesModule)
  }
  ,
  {
    path:'sar-advise-class',
    loadChildren:()=>import('./components/all-sar/sar-advise-class/sar-advise-class.module').then(m=>m.SarAdviseClassModule)
  },
  {
    path:'sar-upload-img',
    loadChildren:()=>import('./components/all-sar/sar-upload-img/sar-upload-img.module').then(m=>m.SarUploadImgModule)
  },
  {
    path:'sar-ordered-position',
    loadChildren:()=>import('./components/all-sar/sar-ordered-position/sar-ordered-position.module').then(m=>m.SarOrderedPositionModule)
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
